import * as React from 'react';
import { View, FlatList, Text, Image, TouchableOpacity, StyleSheet, SectionList } from "react-native";

// import { Ionicons } from '@expo/vector-icons';
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import { ProductContext } from '../../contexts/product/Store';
import { CartContext } from '../../contexts/cart/Store';

import AddEditCartItemModal from '../modals/AddEditCartItemModal';
import { AnalyticsService } from '../../constants/Analytics';
import { AuthContext } from '../../contexts/auth/Store';
import ProductView from './ProductView';
import ProductViewList from './ProductViewList';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'

const analytics = new AnalyticsService

const ProductList = function ({ productList }) {

    const authenticator = React.useContext(AuthContext)
    const buyer = authenticator.getUserData.buyerData

    const { product_state, product_dispatch } = React.useContext(ProductContext)
    const [cartState, cartDispatch] = React.useContext(CartContext)

    const [modalState, setModalState] = React.useState(false)
    const [editModalState, setEditModalState] = React.useState(false)
    const [cartPreflight, setCartPreflight] = React.useState(null)
    const [cartPostflight, setCartPostflight] = React.useState(null)


    const hideModal = () => {
        setModalState(false)
        setEditModalState(false)
        setCartPreflight(null)
        setCartPostflight(null)
    }

    const openModal = (item) => {
        // if (cartState && cartState.order_group_items) {
        //     let found_in_cart = cartState.order_group_items.filter(x => {
        //         return x.product_id === item._id
        //     })
        //     if (found_in_cart.length) {
        //         // spawn edit modal
        //         setCartPostflight(found_in_cart[0])
        //         setEditModalState(true)
        //     } else {
        //         // spawn add modal
        //         setCartPreflight(item)
        //         setModalState(true)
        //     }
        // } else {
        //     // spawn add modal
        //     setCartPreflight(item)
        //     setModalState(true)
        // }

        setCartPreflight(item)
        setModalState(true)

        analytics.logEvent('Viewed Product', buyer, {
            product_id: item._id,
            product_name: item.name
        })
        analytics.googleHelpers.setCurrentScreen('ViewedProduct', 'ViewedProduct')
    }

    const setProductView = (config) => {
        product_dispatch({ type: 'SET_PRODUCT_VIEW', payload: config })
    }

    const SingleProduct = function ({ item }) {
        return (<>
            <View style={[
                product_state?.product_view === 'grid' ? styles.itemWrapper : styles.itemWrapperGrid
            ]}>
                <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={() => { openModal(item) }}
                    style={[
                        product_state?.product_view === 'grid' && { flex: 1 }
                    ]}
                >
                    {
                        product_state?.product_view === 'grid'
                            ? <ProductView product={item} />
                            : <ProductViewList product={item} />
                    }
                </TouchableOpacity>
            </View>
        </>
        )
    }

    const DummyProduct = function ({ item }) {
        return (
            <>
                {
                    product_state?.product_view === 'grid'
                        ? <View style={styles.itemWrapper}>
                            <View style={styles.dummyCard}></View>
                        </View>
                        : <View style={styles.itemWrapperGrid}>
                            <View style={[styles.dummyCard, { minHeight: 100 }]}></View>
                        </View>
                }
            </>
        )
    }

    const SectionHeader = function ({ section: { type, data } }) {
        return type === 'exact'
            ? <>
                {
                    data[0].list.length
                        ? null
                        : <View style={styles.emptyContainer}>
                            <Image source={require('../../assets/images/main/folder-grey.png')} style={styles.emptyImage} />
                            <Text style={styles.emptyText}>We couldn’t find any products that match your search</Text>
                        </View>
                }
            </>
            : <>
                {
                    data[0].list.length
                        ? <Text style={[styles.sectionHeader, { marginTop: 20 }]}>More search results</Text>
                        : null
                }
            </>
    }

    const SectionFlatList = function ({ item }) {

        return (
            <FlatList
                initialNumToRender={10}
                data={item.list}
                renderItem={SingleProduct}
                keyExtractor={item => item._id}
                key={product_state?.product_view === 'list' ? 1 : 2}
                numColumns={product_state?.product_view === 'list' ? 1 : 2}
                contentContainerStyle={styles.listWrapper}
            />
        )
    }

    return (
        <View style={{
            flex: 1,
            flexGrow: 1
        }}>
            <View style={styles.listMenu}>
                <Text style={styles.listMenuText}>{productList?.length} product{productList?.length > 1 && 's'} found</Text>

                <TouchableOpacity style={styles.listMenuIcon} onPress={() => setProductView('grid')}><Icon name='md-grid' size={24} color={product_state?.product_view === 'grid' ? Colors.tintColor : Colors.shades._1} /></TouchableOpacity>
                <TouchableOpacity style={styles.listMenuIcon} onPress={() => setProductView('list')}><Icon name='md-menu' size={24} color={product_state?.product_view === 'list' ? Colors.tintColor : Colors.shades._1} /></TouchableOpacity>
            </View>

            {
                product_state.loading
                    ? <FlatList
                        initialNumToRender={10}
                        data={[0, 1, 2, 3]}
                        renderItem={DummyProduct}
                        keyExtractor={item => '_' + item}
                        key={product_state?.product_view === 'list' ? 1 : 2}
                        numColumns={product_state?.product_view === 'list' ? 1 : 2}
                        contentContainerStyle={styles.listWrapper}
                    />
                    : product_state.search_result.length && product_state.query !== ''
                        ? <SectionList
                            sections={[
                                {
                                    type: 'exact',
                                    key: 'exact',
                                    data: [
                                        {
                                            key: 'exact',
                                            list: product_state.search_result_exact
                                        }
                                    ]
                                },
                                {
                                    type: 'match',
                                    key: 'match',
                                    data: [
                                        {
                                            key: 'match',
                                            list: product_state.search_result_match
                                        }
                                    ]
                                }
                            ]}
                            renderItem={SectionFlatList}
                            contentContainerStyle={styles.listWrapper}
                            renderSectionHeader={SectionHeader}
                        />
                        : <FlatList
                            initialNumToRender={10}
                            data={productList || []}
                            renderItem={SingleProduct}
                            keyExtractor={item => item._id}
                            key={product_state?.product_view === 'list' ? 1 : 2}
                            numColumns={product_state?.product_view === 'list' ? 1 : 2}
                            contentContainerStyle={styles.listWrapper}
                        />
            }
            {cartPreflight && <AddEditCartItemModal modalState={modalState} product={cartPreflight} hideModal={hideModal} />}
        </View>
    )
}

export default ProductList

const styles = StyleSheet.create({
    listMenu: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        flexDirection: 'row'
    },
    listMenuText: {
        alignSelf: 'center',
        flexGrow: 1,
        width: 122,
        color: Colors.shades._7,
        ...FontStyles.size13,
        ...FontStyles.lh13,
        ...FontStyles.normal,
    },
    listMenuIcon: {
        alignSelf: 'center',
        padding: 3,
        marginLeft: 10,
    },
    listWrapper: {
        paddingHorizontal: 6,
    },
    itemWrapper: {
        width: '50%',
        paddingHorizontal: 5,
        marginBottom: 10,
    },
    itemWrapperGrid: {
        // width: '100%',
        paddingHorizontal: 5,
        marginBottom: 6,
    },
    dummyCard: {
        borderColor: '#E5EAF0',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 6,
        backgroundColor: Colors.whiteColor,
        flex: 1,
        opacity: 0.6,
        minHeight: 130,
    },
    sectionHeader: {
        ...FontStyles.size15,
        ...FontStyles.lh20,
        ...FontStyles.bold,
        paddingHorizontal: 6,
        marginBottom: 8,
    },
    emptyContainer: {
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 20,
        marginBottom: 20,
    },
    emptyImage: {
        width: 50,
        height: 40
    },
    emptyText: {
        maxWidth: 215,
        ...FontStyles.normal,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.gray,
        textAlign: 'center',
        marginTop: 18,
    }
})